/**
 * Record List Container Component
 * Wraps the list of IR document records
 */
import React from 'react'
import styled from '@emotion/styled'

const ListWrapper = styled.div`
  margin: 2rem auto;
  padding: 0 2rem;
  max-width: 1200px;

  @media (max-width: 767px) {
    padding: 0 1.25rem;
  }
`

interface RecordListProps {
  children: React.ReactNode
}

const RecordList: React.FC<RecordListProps> = ({ children }) => {
  return <ListWrapper>{children}</ListWrapper>
}

export default RecordList
